import { Button } from '@cibli/shared';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseTypeEnum } from '@/features/common/components/Header';
import MainLayout from '@/features/common/components/MainLayout';

import BrandPulse from '../components/animations/BrandPulse';

const CV_PRINTING_TIMEOUT = 45000;
interface Props {
  onContinue: () => void;
  timeout?: number;
}

export default function CVPrintingScreen({ onContinue, timeout = CV_PRINTING_TIMEOUT }: Props) {
  const { t } = useTranslation();

  useEffect(() => {
    const timerId = setTimeout(() => {
      onContinue();
    }, timeout);

    return () => clearTimeout(timerId);
  }, [onContinue, timeout]);

  return (
    <MainLayout closeType={CloseTypeEnum.End} className="gap-6 sm:gap-10">
      <BrandPulse />

      <h1 className="text-center text-2xl sm:text-3xl font-semibold leading-tight tracking-tight">
        {t('CVPrintingScreen.title')}
      </h1>
      <p className="text-center text-base sm:text-lg text-muted-foreground max-w-xl mx-auto px-4">
        {t('CVPrintingScreen.subtitle')}
      </p>

      <Button size="lg" className="mt-2" onClick={onContinue}>
        {t('CVPrintingScreen.cta')}
      </Button>
    </MainLayout>
  );
}
